import type { SetStateAction, Dispatch } from "react";

/**
 * Given a setState function on an object, this function returns a function
 * that sets a specific node of the object to the value of the event payload.
 *
 * @example
 * const [person, setPerson] = React.useState({ name: "Craig" });
 * <Input id="name" value={name} onChange={setStateNode(setPerson, "name")} />
 */
export function setStateNode<T extends {}, K extends keyof T>(
  setState: Dispatch<SetStateAction<T>>,
  node: K
) {
  return (value: T[K]) => {
    setState((oldState) => {
      return {
        ...oldState,
        [node]: value,
      };
    });
  };
}
